/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Active
 *
 * 1 = Booked
 *
 * 2 = Closed
 */
export enum DifferedRemindersStatusEnum {
  Active = 0,
  Booked = 1,
  Closed = 2,
}
